import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  text: "Cancelé mi agencia el mismo día. Estaba pagando $2,800 al mes por lo que ahora hago yo en una tarde. Me siento estúpido por no haberlo hecho antes.",
  author: "Carlos M.",
  role: "Ecommerce de suplementos"
}, {
  text: "Mi primer anuncio hecho con el protocolo bajó mi costo por clic un 43% en 6 días. Por $11.99. No es lógico lo barato que es esto.",
  author: "Valeria R.",
  role: "Coach de negocios"
}, {
  text: "Llevaba meses peleando con Canva. En 15 minutos con la Bible tenía un creativo que parecía de una marca de lujo. El grupo de WhatsApp vale el precio solo.",
  author: "Andrés T.",
  role: "Agencia de marketing"
}, {
  text: "Pasé de gastar $500 en pruebas a encontrar mi anuncio ganador en el primer intento. El ROI es absurdo.",
  author: "Martín L.",
  role: "Dueño de Tienda Online"
}, {
  text: "La bóveda de prompts es oro puro. Literalmente copié, pegué y mi CTR se duplicó en 24 horas. Mis clientes no lo pueden creer.",
  author: "Sofía C.",
  role: "Media Buyer"
}, {
  text: "Pensé que necesitaba un equipo de video. Ahora hago creativos en pijama que superan a los de mi competencia. Es casi injusto.",
  author: "Diego F.",
  role: "Creador de Contenido"
}, {
  text: "El grupo de WhatsApp es increíble. El feedback directo me salvó de lanzar una campaña que iba a fracasar. Solo por eso pagaría $100 al mes.",
  author: "Laura M.",
  role: "Emprendedora"
}, {
  text: "Nunca había usado IA para mis anuncios. El paso a paso es tan claro que mi abuela podría hacerlo. Resultados en el primer día.",
  author: "Roberto G.",
  role: "Consultor"
}];

// Dividimos los testimonios en dos filas para el efecto de carrusel doble
const row1 = testimonials.slice(0, 4);
const row2 = testimonials.slice(4, 8);
const TestimonialCard = ({
  t
}: {
  t: typeof testimonials[0];
}) => <div className="w-[400px] shrink-0 p-8 rounded-2xl bg-zinc-900 border border-zinc-800 relative flex flex-col justify-between" data-id="element-179" data-mp="1xi90z4dcp5aw">
    <Quote className="absolute top-6 right-6 w-8 h-8 text-zinc-800" data-id="element-180" data-mp="1sjfnvd1z7gb9" />
    <div data-id="element-181" data-mp="1ogj9jyjgy6d4">
      <div className="flex gap-1 mb-6" data-id="element-182" data-mp="1og9lwhlwcbal">
        {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-183" data-mp="1jirbems8do0h" data-mpi={j} />)}
      </div>
      <p className="text-zinc-300 mb-8 relative z-10" data-id="element-184" data-mp="1ejofpsy54u56">"{t.text}"</p>
    </div>
    <div data-id="element-185" data-mp="19ses0xw5k0vx">
      <p className="text-white font-bold" data-id="element-186" data-mp="19soggh1jtzzi">{t.author}</p>
      <p className="text-zinc-500 text-sm" data-id="element-187" data-mp="19r3o8y2pit4t">{t.role}</p>
    </div>
  </div>;
export function Testimonials() {
  return <section className="py-12 md:py-24 bg-zinc-950 overflow-hidden" data-id="element-188" data-mp="14qz1wrf4b46o">
      <div className="max-w-6xl mx-auto px-4" data-id="element-189" data-mp="10tb7dphc7dfb">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-190" data-mp="vsdotbsf0hda">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-191" data-mp="32hfdh7lwxseu">
            Mientras Tú Lo Piensas, Ellos Ya Están Facturando
          </h2>
          <p className="text-xl text-zinc-400" data-id="element-192" data-mp="37e5t5ttt2lzq">Lo que dicen los que ya dejaron de pagar de más</p>
        </motion.div>
      </div>

      <div className="relative flex flex-col gap-6 w-full" data-id="element-193" data-mp="3ggosi3ydugh8">
        {/* Gradientes laterales para suavizar la entrada/salida */}
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-zinc-950 to-transparent z-10 pointer-events-none" data-id="element-194" data-mp="2jr7gl78t3y73" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-zinc-950 to-transparent z-10 pointer-events-none" data-id="element-195" data-mp="2oq0siv8g3h55" />

        {/* Fila 1 - Scroll hacia la izquierda */}
        <div className="flex w-full overflow-hidden" data-id="element-196" data-mp="2xiultwkq8h20">
          <motion.div animate={{
          x: ["0%", "-50%"]
        }} transition={{
          ease: "linear",
          duration: 30,
          repeat: Infinity
        }} className="flex gap-6 w-max pr-6" data-id="element-197" data-mp="20zws0wqjzxid">
            {[...row1, ...row1].map((t, i) => <TestimonialCard key={`r1-${i}`} t={t} data-id="element-198" data-mp="1lxondi7q7ael" data-mpi={i} />)}
          </motion.div>
        </div>

        {/* Fila 2 - Scroll hacia la derecha */}
        <div className="flex w-full overflow-hidden" data-id="element-199" data-mp="1vmg8b6edcug0">
          <motion.div animate={{
          x: ["-50%", "0%"]
        }} transition={{
          ease: "linear",
          duration: 35,
          repeat: Infinity
        }} className="flex gap-6 w-max pr-6" data-id="element-200" data-mp="1vo9g4p0pxkpl">
            {[...row2, ...row2].map((t, i) => <TestimonialCard key={`r2-${i}`} t={t} data-id="element-201" data-mp="1zojv2r6hnlgl" data-mpi={i} />)}
          </motion.div>
        </div>
      </div>
    </section>;
}